import React from 'react';
import { Link } from 'react-router-dom';
import { HeartIcon } from '@heroicons/react/24/outline';

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          
          {/* Brand Section */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold">Paipers</h3>
            <p className="text-gray-300 text-sm leading-relaxed">
              AI-powered insights from the latest HCI research papers. 
              Discover UX patterns, get intelligent summaries, and stay ahead of design trends.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-200 uppercase tracking-wider">Explore</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors duration-150 text-sm">
                  Latest Papers
                </Link>
              </li>
              <li>
                <Link to="/patterns" className="text-gray-300 hover:text-white transition-colors duration-150 text-sm">
                  UX Patterns
                </Link>
              </li>
              <li>
                <Link to="/favorites" className="text-gray-300 hover:text-white transition-colors duration-150 text-sm">
                  My Favorites
                </Link>
              </li>
            </ul>
          </div>

          {/* Tech Info */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold text-gray-200 uppercase tracking-wider">Powered By</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>OpenAI GPT for AI Summaries</li>
              <li>arXiv API for Research Papers</li>
              <li>Pattern Detection AI</li>
              <li>Smart Search & Recommendations</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="flex items-center space-x-1 text-sm text-gray-400">
            <span>Made with</span>
            <HeartIcon className="h-4 w-4 text-red-500" />
            <span>for UX Research</span>
          </div>
          
          <div className="mt-4 md:mt-0 text-sm text-gray-400">
            © 2025 Paipers. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;